function trackFacebookEvent(eventType, eventName, data = {}) {
  if (!window.fbq) {
    console.log(`Skip event tracking. Facebook Pixel not initialized.`, eventType, eventName, data);
    return;
  }
  window.fbq(eventType, eventName, data);
}

function loadFacebookPixel(callback) {
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  trackFacebookEvent('init', '6721006014590604');
  trackFacebookEvent('track', 'PageView');

  if (callback) {
    callback();
  }
}

export default loadFacebookPixel;